import { createFileRoute } from "@tanstack/react-router";
import ArticleDetailWrapper from "@/components/ArticleDetailWrapper";
import { articleRouteHead } from "@/lib/articleRouteHead";
import { loadArticleSeo } from "@/lib/routeSeo";

export const Route = createFileRoute("/ratgeber/$slug")({
  loader: ({ params }) => loadArticleSeo(params.slug),
  head: ({ params, loaderData }) => articleRouteHead(params.slug, loaderData),
  component: ArticleDetailWrapper,
});
